import { Button } from 'antd';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import History from '../../Training/History';

const Training = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [training, setTraining] = useState([]);

  useEffect(() => {
    fetchTrainingHistory();
  }, [id]);

  const fetchTrainingHistory = () => {
    const url = `/training/history`;
  }

  return (
    <>
      <Link to={`/training/create?id=${id}`}><Button type="primary">Update Data Training</Button></Link>
      <div className="gx-mt-3">
        <History id={id} />
      </div>
    </>
  );
}

export default Training;